import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    chip: {
        minWidth: 300,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        paddingTop: 25,
        paddingBottom: 25,
        margin: 5,
        border: '1px solid',
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main
    },
    playlistInfoContainer: {
        marginLeft: 15,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    previewIcon: {
        color: "#3F51B5",
        marginLeft: 5
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "center"
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: "center",
        marginLeft: 10
    },
    name: {
        color: theme.palette.text.primary,
        fontWeight: "bold"
    },
    additionalInfo: {
        color: theme.palette.text.secondary
    },
    noMaxWidth: {
        maxWidth: 'none',
    }
}));

export {useStyles};
